import { useLocalNotifications } from '@/hooks/useLocalNotifications';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { useAndroidBackButton } from '@/hooks/useAndroidBackButton';
import { useDeepLinks } from '@/hooks/useDeepLinks';
import { NativeNotificationPrompt } from '@/components/NativeNotificationPrompt';

// NOTE: setNavigateRef is wired by <NavigateRefSetter /> at the top of the tree
// (directly under BrowserRouter) so cold-start push taps don't fall back to
// window.location.href before this provider-nested component mounts.

export const PushNotificationInitializer = () => {
  useLocalNotifications();
  usePushNotifications();
  useAndroidBackButton();
  useDeepLinks();
  return <NativeNotificationPrompt />;
};
